import { useParams } from 'react-router';

import { useAppSelector } from '../../../../../../store/hooks';
import { VehicleReportModel } from '../../../../models/vehicle-report.model';
import { VehicleReportsTableConfigModel } from '../../models/vehicle-reports-table-config.model';

export const useGetVehicleReportsTableConfig =
  (): VehicleReportsTableConfigModel => {
    const { id: campaignId } = useParams();

    const tableRows: VehicleReportModel[] = useAppSelector(
      state => state.campaignsFeature.vehicleReports.reports
    );

    const isLoading: boolean = useAppSelector(state => state.root.isLoading);

    const count = useAppSelector(
      state => state.campaignsFeature.vehicleReports.pagination.totalCount
    );

    const rowsPerPage = useAppSelector(
      state => state.campaignsFeature.vehicleReports.pagination.size
    );

    const page = useAppSelector(
      state => state.campaignsFeature.vehicleReports.pagination.pageNumber
    );

    return {
      tableRows,
      isLoading,
      campaignId,
      count,
      page,
      rowsPerPage,
    };
  };
